import { ITableItem } from '@u1/aligntech-uikit';
import React from 'react';
import useStyles from './Cross.styles';

type CrossProps = {
  user?: ITableItem;
  onClick: (user?: ITableItem) => void;
};

export const Cross: React.FC<CrossProps> = ({ user, onClick }) => {
  const classes = useStyles();

  return (
    <div
      className={classes.root}
      onClick={() => onClick(user)}
      data-qa-name="close_icon"
    >
      <i className={classes.deleteIcon} data-qa-name="delete_icon" />
    </div>
  );
};
